(function($) {

	// @todo CLEAN this up and add it to individual js files


	// double image effect // client wanted to remove the original designed effect
	// $('.image-effect-wrapper').each(function() {
	// 	var imgsrc = $(this).find('img').attr('src');
	// 	$(this).find('img').css({
	// 		'box-shadow': '0 0 43.74px 10.26px rgba(13,19,22,.19)'
	// 	});
	// 	$(this).css({
	// 		'background-image':'url(' + imgsrc + ')',
	// 		'display':'inline-block',
	// 		'background-size':'cover',
	// 		'padding':'20px',
	// 		'box-shadow': '0 0 43.74px 10.26px rgba(13,19,22,.19)'
	// 	});
	// });


	// Banner toggle equipment menu
	$('a.banner-equipment-nav').click(function () {
		// alert('click happened');
		$('.banner-equipment-nav').toggleClass('flip-icon');
		$('.equipment-menu').toggleClass('show-equipment');
		$('header.banner').toggleClass('equipment-open');
	});

	// for the section navigation selector thing
	$('#gencor-training .training-navigation-wrapper .training-nav li:nth-child(n+2) > a').hover(function() {
		$('#gencor-training .training-navigation-wrapper .training-nav li:first-of-type > a').toggleClass('remove-hover');
	});
	$('.slider-navigation-wrapper .slider-nav li:nth-child(n+2) > a').hover(function() {
		$('.slider-navigation-wrapper .slider-nav li:first-of-type > a').toggleClass('remove-hover');
	});

	$('.slider-navigation-wrapper .slider-nav a.photos').on('click', function() {
		if ( $('.body-images').hasClass('photos') ) {
			return;
		} else {
			$('.body-images').addClass('photos');
		}
	});
	$('.slider-navigation-wrapper .slider-nav a.videos').on('click', function() {
		if ( $('.body-images').hasClass('photos') ) {

			$('.body-images').removeClass('photos');

			if( $('.equipment-videos').hasClass('slick-initialized') ) {
				return;
			} else {
				$('.equipment-videos').slick({
				   	fade: true,
				   	dots: false,
				   	adaptiveHeight: false,
					infinite: true,
					autoplay: false,
					arrows: false
				 });
				$('.equipment-videos-nav').slick({
					slidesToShow: 5,
					slidesToScroll: 1,
					asNavFor: '.equipment-videos',
					dots: false,
					// centerMode: true,
					focusOnSelect: true,
					arrows: false
				});
				$('.equipment-videos-nav video').each(function() {
					$(this).unbind('click');
				});
			}
		} else {
			return;
		}
	});

	$('.featherlight-previous, .featherlight-next').find('img').replaceWith('>');

	// $('a[class*=details-gallery], a[class*=variation-gallery], a[class*=media-gallery], a[class*=training-gallery], a[class*=event-gallery]').featherlightGallery({
	// 		previousIcon: '<',
	// 		nextIcon: '>',
	// 		galleryFadeIn: 300,

	// 		openSpeed: 300
	// 	});
	// $('a[class*=details-gallery]').featherlightGallery({
	// 	previousIcon: '<',
	// 	nextIcon: '>',
	// 	galleryFadeIn: 300,

	// 	openSpeed: 300
	// });

	// $('a[class*=variation-gallery]').featherlightGallery({
	// 	previousIcon: '<',
	// 	nextIcon: '>',
	// 	galleryFadeIn: 300,

	// 	openSpeed: 300
	// });

	// $('a[class*=media-gallery]').featherlightGallery({
	// 	previousIcon: '<',
	// 	nextIcon: '>',
	// 	galleryFadeIn: 300,

	// 	openSpeed: 300
	// });

	// $('a[class*=training-gallery]').featherlightGallery({
	// 	previousIcon: '<',
	// 	nextIcon: '>',
	// 	galleryFadeIn: 300,

	// 	openSpeed: 300
	// });

	// $('a[class*=event-gallery]').featherlightGallery({
	// 	previousIcon: '<',
	// 	nextIcon: '>',
	// 	galleryFadeIn: 300,

	// 	openSpeed: 300
	// });

})(jQuery);